import { ITheme } from "../../slate/Theme";
import { ICheckbox } from "../../slate/Theme/Checkbox";

import Checkbox from "./Checkbox";

export const getCheckboxColors = (
  props: Checkbox.IProps,
  theme: ITheme
): ICheckbox => {
  let colors;
  if (props.disabled) {
    colors = theme.checkboxes.disabled;
  } else if (props.secondary) {
    colors = theme.checkboxes.secondary;
  } else {
    colors = theme.checkboxes.primary;
  }
  const fill = props.color ?? colors.fill;
  const isActive = props.checked || props.intermediate;
  return {
    fill,
    icon: props.color ?? colors.icon,
    border:
      props.borderColor ?? (isActive ? colors.borderActive : colors.border),
    borderActive: colors.borderActive,
    base: colors.base,
    checked: colors.checked,
    hover: colors.hover,
  };
};
